import { RankState } from './reducer';

const localState = (state: any): RankState => state.rank;

export const selectors = {
    ranks: (state) => localState(state).ranks,
    area: (state) => localState(state).area,
    rankById: (state, id: string) => {
        const ranks = localState(state).ranks;
        return Array.isArray(ranks) ? ranks.find((rank) => rank.id === id) : undefined;
    },
    dispatchGroups: (state) => localState(state).dispatchGroups,
};
